module.exports = __webpack_public_path__ + "img/Arabidopsis_thaliana.8a409766.jpg";